'use strict';

(function ($) {
    $.agito = $.agito || {};
    $.agito.urlHelper = $.agito.urlHelper || {};

    $.agito.urlHelper.getParameterByName = function (url, name) {
        name = name.replace(/[\[]/g, "\\[").replace(/[\]]/g, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(url);
        return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    $.agito.urlHelper.updateQueryStringParameter = function (url, key, value) {

        try {
            var url2 = new URL(url);
            url2.searchParams.set(key, value);
            return url2.href;
        } catch (error) {
            var url2 = new URL('https://xxxxxxxxxx' + url);
            url2.searchParams.set(key, value);

            return url2.href.replace('https://xxxxxxxxxx', '');
        }
    };
})($);